import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStateService } from '../states/auth-state.service';

/**
 * Restringe el acceso a una ruta según un permiso.
 * La ruta debe declarar el permiso requerido en `data.permission`.
 * Si no se declara permiso, solo exige autenticación.
 */
export const permissionGuard: CanActivateFn = (route, state) => {
  const authState = inject(AuthStateService);
  const router = inject(Router);

  const user = authState.currentUserValue;
  if (!user) {
    router.navigate(['login']);
    return false;
  }

  const required = route.data?.['permission'] as string | undefined;
  if (!required) {
    return true;
  }

  const permissions = user.permissions ?? [];
  if (permissions.includes(required)) {
    return true;
  }

  // Sin permiso: lo enviamos al inicio del dashboard.
  router.navigate(['/dashboard/inicio']);
  return false;
};
